const BASE_STATE_ACTIONS = {
    TOGGLE_LANGUAGE: 'toggleLanguage',
    SET_PAGE_TITLE: 'setPageTitle',
    SET_BASE_STATE: 'setBaseState',
    SET_PROJECS: 'setProjects',
    SET_PAGES:  'setPages',
    SET_NEWS: 'setNews'
}

export default BASE_STATE_ACTIONS